const INBOUND_BASE_URL = process.env.REACT_APP_INBOUND_API_BASE_URL;

const API_GET_CHART_DATA = `${INBOUND_BASE_URL}/entries/workshop/unloading-points/report`;
const API_GET_THRESHOLD_DATA = `${INBOUND_BASE_URL}/entries/workshop/threshold-capacity/`;
const API_GET_DLZ_DATA = `${INBOUND_BASE_URL}/entries/material/threshold-capacity`;
const API_GET_EXTERNAL_WAREHOUSES_SATURATION = `${INBOUND_BASE_URL}/entries/workshop/saturation/external-warehouses`;
const API_SET_THRESHOLD_DATA = `${INBOUND_BASE_URL}/entries/workshop/threshold-capacity`;
const API_SET_DLZ_DATA = `${INBOUND_BASE_URL}/entries/material/threshold-capacity`;
const API_GET_SYSTEM_ALERTS = `${INBOUND_BASE_URL}/entries/system-alerts`;
const API_GET_TRUCKS_IN_PLANT_BY_WORKSHOP = `${INBOUND_BASE_URL}/entries/workshop/trucks-in-plant`;
const API_GET_TRUCKS_IN_PARKING = `${INBOUND_BASE_URL}/entries/workshop/trucks-in-plant/parking`;
const API_GET_UNLOADING_POINTS_AVERAGE_DLZ = `${INBOUND_BASE_URL}/entries/workshop/unloading-points/average-dlz`;
const API_GET_TRUCKS_IN_PLANT_UNLOADING_BUFFER = `${INBOUND_BASE_URL}/entries/workshop/trucks-in-plant/unloading-buffer`;
const API_GET_TRUCKS_IN_PLANT_WAITING_TO_ARRIVE = `${INBOUND_BASE_URL}/entries/workshop/trucks-in-plant/waiting-to-arrive`;
const API_GET_TRUCKS_IN_PLANT_URGENT = `${INBOUND_BASE_URL}/entries/workshop/urgent`;
const API_GET_UNLOADING_POINT_INFO = `${INBOUND_BASE_URL}/entries/workshop/trucks-in-plant`;

export {
  API_GET_CHART_DATA,
  API_GET_THRESHOLD_DATA,
  API_GET_DLZ_DATA,
  API_GET_EXTERNAL_WAREHOUSES_SATURATION,
  API_SET_THRESHOLD_DATA,
  API_SET_DLZ_DATA,
  API_GET_SYSTEM_ALERTS,
  API_GET_TRUCKS_IN_PLANT_BY_WORKSHOP,
  API_GET_TRUCKS_IN_PARKING,
  API_GET_UNLOADING_POINTS_AVERAGE_DLZ,
  API_GET_TRUCKS_IN_PLANT_UNLOADING_BUFFER,
  API_GET_TRUCKS_IN_PLANT_WAITING_TO_ARRIVE,
  API_GET_TRUCKS_IN_PLANT_URGENT,
  API_GET_UNLOADING_POINT_INFO
};
